export default "__VITE_ASSET__B833EKkP__"